<template>
  <div class="max-w-screen-3xl mx-auto" data-testid="narrow-container">
    <slot />
  </div>
</template>
